// extracted by mini-css-extract-plugin
export var chip = "_fq-0";
export var filterDropdown = "_fq-5";
export var filterItem = "_fq-6";
export var icon = "_fq-1";
export var removeButton = "_fq-3";
export var removeIcon = "_fq-4";
export var separator = "_fq-2";